/* Stock requests use the shop server; credentials and Discord stay server-side. */
(() => {
  'use strict';
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-stock-language]');
    if (!link) return;
    const url = new URL(location.href);
    url.searchParams.set('lang', link.dataset.stockLanguage);
    link.href = url.pathname + url.search;
  });
  for (const panel of document.querySelectorAll('[data-stock-notification]')) {
    const preview = panel.dataset.mode === 'preview';
    const product = panel.closest('[data-product]');
    const variants = JSON.parse(product.querySelector('[data-product-data]').textContent).variants;
    const copy = JSON.parse(panel.querySelector('[data-stock-copy]').textContent);
    const form = panel.querySelector('[data-stock-form]'), email = form.elements.email;
    const button = panel.querySelector('[data-stock-submit]');
    const error = panel.querySelector('[data-stock-error]'), status = panel.querySelector('[data-stock-status]');
    const success = panel.querySelector('[data-stock-success]');
    let currentId = null, pending = false, controller = null, generation = 0;
    form.noValidate = true;
    const reset = () => {
      generation++; controller?.abort(); controller = null; pending = false;
      form.reset(); form.hidden = false; success.hidden = true;
      error.hidden = true; error.textContent = ''; email.removeAttribute('aria-invalid');
      button.disabled = false; button.textContent = copy.submit;
      form.removeAttribute('aria-busy'); status.textContent = '';
    };
    const sync = () => {
      const selected = product.querySelector('[data-variant-id]')?.value;
      const variant = variants.find(v => String(v.id) === selected);
      const nextId = variant ? String(variant.id) : '';
      if (currentId !== nextId) { reset(); currentId = nextId; }
      const soldOut = product.dataset.stockSoldOut === undefined ? !variant?.available : product.dataset.stockSoldOut === 'true';
      panel.hidden = !variant || !soldOut;
      product.classList.toggle('stock-notification-active', !panel.hidden);
      form.elements.variant_id.value = nextId;
    };
    document.addEventListener('change', event => {
      if (product.contains(event.target) && event.target.matches('[data-option],[data-sticky-variant]')) sync();
    });
    product.addEventListener('product:stock-changed', sync);
    email.addEventListener('input', () => { error.hidden = true; email.removeAttribute('aria-invalid'); });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (pending || panel.hidden || success.hidden === false) return;
      email.value = email.value.trim();
      if (!email.checkValidity()) {
        error.textContent = copy.invalid; error.hidden = false;
        email.setAttribute('aria-invalid', 'true'); email.focus(); return;
      }
      const requestGeneration = ++generation;
      controller = new AbortController(); pending = true;
      const requestController = controller;
      const timeout = setTimeout(() => requestController.abort(), 12000);
      button.disabled = true; button.textContent = copy.pending;
      form.setAttribute('aria-busy', 'true'); status.textContent = copy.pending;
      error.hidden = true; email.removeAttribute('aria-invalid');
      try {
        const values = {email: email.value, variantId: currentId, locale: panel.dataset.locale};
        const endpoint = preview ? '/api/preview/back-in-stock' : 'https://ivonne.hageneez.nl/api/stock-notifications';
        const payload = preview ? {...values, scenario: document.querySelector('#stock-preview-scenario')?.value || 'success'} : values;
        const response = await fetch(endpoint, {
          method: 'POST', headers: {'Content-Type': 'application/json'}, credentials: 'omit',
          signal: requestController.signal, body: JSON.stringify(payload)
        });
        if (requestGeneration !== generation) return;
        if (preview) {
          if (!response.ok) throw new Error('Preview request failed');
          const result = await response.json();
          if (requestGeneration !== generation) return;
          if (result.simulated !== true || result.variantId !== currentId || result.locale !== panel.dataset.locale) throw new Error('Invalid preview response');
        } else if (response.status !== 202) throw new Error('Stock subscription failed');
        form.hidden = true; email.value = ''; success.hidden = false;
        status.textContent = copy.success; success.focus();
      } catch (failure) {
        if (requestGeneration !== generation) return;
        error.textContent = copy.error; error.hidden = false;
        status.textContent = ''; button.focus();
      } finally {
        clearTimeout(timeout);
        if (requestGeneration === generation) {
          pending = false; controller = null; form.removeAttribute('aria-busy');
          button.disabled = false; button.textContent = copy.submit;
        }
      }
    });
    sync();
  }
})();
